import { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import en from '../../../lang/en-us';
import { SubmitButtonWithLoader } from '../../../lib/Button';
import { OtpField, ResendOtp, useTimer } from '../../../lib/OtpField';
import {
    verifyChangeEmailOTP as verifyOTP,
    updateEmail,
    sendPhoneOTP as sendOtp,
    updateMobile,
} from '../../../redux-store/actions/nct';
import { RootStateType } from '../../../redux-store/reducers';
import { OTP_ACTIONS, REGISTER_WITH_EMAIL } from '../../../utils/constants';
import { maskMobileNumber } from '../../../utils/utilityFunctions';
import { ActionHeader } from '../makeNct';
const { dashboard } = en;

const initState = {
    otp: null,
    reqId: null,
    otpRef: null,
};

function UnregisteredOtp(props: any) {
    const action =
        props.userRegisteredWith === REGISTER_WITH_EMAIL
            ? OTP_ACTIONS.UNREGISTERED_EMAIL_CHANGE
            : OTP_ACTIONS.UNREGISTERED_MOBILE_CHANGE;

    const { enteredEmail, foliosToUpdate = [] } = props.location.state || {};
    const [otpInput, setOtp] = useState<any>(new Array(6).fill(''));
    const [count, setCount] = useState(0);
    const [{ otp, reqId, otpRef }, setOtpInfo] = useState(initState);
    const { timer, startTimer, resetTimer } = useTimer({});
    const [loading, setLoading] = useState<boolean>(false);
    const [showModal, setShowModal] = useState<boolean>(false);

    useEffect(() => {
        const { otp, reqId, otpRef } = props.location.state || {};
        if (!props.location.state) {
            props.history.push('/');
            return;
        }
        setOtpInfo({
            otp,
            reqId,
            otpRef,
        });
    }, []);

    console.log(props);

    const handleSubmit = async () => {
        setLoading(true);
        try {
            const { pan = '', pekrn = '', mobile = '', email } = props;
            const images = props?.imageInfo?.data;
            const payload = {
                enteredOtp: otpInput.join(''),
                otpRef,
                reqId,
                email,
                mobile,
                pan,
                pekrn,
                action,
            };

            await props.verifyOTP(payload);
            const body = {
                reqId,
                mobile,
                pan: props.pan,
                pekrn: props.pekrn,
                source: 'U',
                data: foliosToUpdate,
                images,
                email,
            };
            let res =
                props.userRegisteredWith === REGISTER_WITH_EMAIL
                    ? await props.updateEmail(body)
                    : await props.updateMobile(body);
            props.history.replace('unregistered-folios-success', {
                data: foliosToUpdate,
                email: enteredEmail,
                ...(res || {}).body,
            });
            return;
        } catch (err: any) {
            alert(err.message);
        } finally {
            setLoading(false);
        }
    };

    const onResend = async () => {
        setShowModal(true);
        try {
            const { pan = '', pekrn = '' } = props;
            let payload = { pan, pekrn, action };
            let res = await props.sendOtp(payload);
            setOtpInfo({ ...(res || {}).body });
            setOtp(new Array(6).fill(''));
            resetTimer();
        } catch (err: any) {
            alert(err.message);
        }
    };

    return (
        <div className="curved-bg">
            <ActionHeader header={dashboard.changeEmail.changeEmailHeading} />
            <div className="curved-bg-content">
                <img className="change-email-img" src="/images/change-otp-img.png" alt="" />
                <div className="curved-bg-content-inner">
                    <div className="curved-bg-content-inner-top">
                        <h3 className="subheading">
                            {dashboard.OtpScreen.subHeading}
                            <span>{dashboard.OtpScreen.subHeadingSpan}</span>
                        </h3>
                        <p>
                            {dashboard.OtpScreen.otpPhoneSubject}{' '}
                            <span>
                                "{!!props.mobile ? maskMobileNumber(props.mobile) : props.email}"
                            </span>
                        </p>
                        <OtpField
                            value={otpInput}
                            updateValue={(otp: string[]) => {
                                setCount(count + 1);
                                setOtp(otp);
                            }}
                            showModal={showModal}
                            _handleProceed={() => setShowModal(false)}
                        />
                    </div>
                    <div className="curved-bg-content-inner-bottom">
                        <SubmitButtonWithLoader
                            disabled={otpInput.join('').length !== 6}
                            loading={loading}
                            label={dashboard.OtpScreen.buttonText}
                            labelWhileLoading={dashboard.OtpScreen.buttonTextWhileLoading}
                            onClick={handleSubmit}
                        />
                        <ResendOtp counter={timer} onResendOtp={onResend} startTimer={startTimer} />
                    </div>
                </div>
            </div>
        </div>
    );
}

export default connect(
    ({ authReducer, portfolio }: RootStateType) => ({ ...authReducer, ...portfolio }),
    {
        verifyOTP,
        updateEmail,
        sendOtp,
        updateMobile,
    },
)(UnregisteredOtp);
